<template>
    <div class="carBox">
        <el-card class="box-card" style="width: 600px;margin-right: 20px">
            <div class="mainBody">
                <div class="dataBox">
                    <el-table :data="report_list" border stripe empty-text="暂无工作中的非接触设备">
                        <el-table-column prop="device_code" label="设备编号" sortable="custom" width="120"></el-table-column>
                        <el-table-column prop="hole_code" label="孔号" sortable="custom" width="120"></el-table-column>
                        <el-table-column prop="hole_order" label="孔序" sortable="custom" width="100"></el-table-column>
                        <el-table-column prop="segment_no" label="段号" sortable="custom" width="100"></el-table-column>
                        <el-table-column label="操作" width="100" align="center">
                            <template slot-scope="scope">
                                <LabBtns :menu_id="menu_id" :row="scope.row" :index="scope.$index" :menus="lab_btns" @on_btnclk="labelClick"></LabBtns>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
        </el-card>
        <el-card class="box-card" style="width: calc(100% - 625px)">
            <el-row style="width: 100%">
                <el-col :span="24">
                    <el-card class="box-card">
                        <div class="el-table el-table--fit el-table--striped el-table--border el-table--enable-row-hover el-table--enable-row-transition">
                            <div class="el-table__body-wrapper is-scrolling-none">
                                <table class="el-table__body" width="100%" cellspacing="0" cellpadding="0" border="0">
                                    <tbody>
                                        <tr class="el-table__row">
                                            <td class="el-table__cell is-right">
                                                <div class="cell"><span>孔号：</span></div>
                                            </td>
                                            <td class="el-table__cell">
                                                <div class="cell"><span>{{report_working.hole_code}}</span></div>
                                            </td>
                                            <td class="el-table__cell is-right">
                                                <div class="cell"><span>孔序：</span></div>
                                            </td>
                                            <td class="el-table__cell">
                                                <div class="cell"><span>{{report_working.hole_order}}</span></div>
                                            </td>
                                            <td class="el-table__cell is-right">
                                                <div class="cell"><span>段号：</span></div>
                                            </td>
                                            <td class="el-table__cell">
                                                <div class="cell"><span>{{report_working.segment_no}}</span></div>
                                            </td>
                                            <td class="el-table__cell is-right">
                                                <div class="cell"><span>作业方式：</span></div>
                                            </td>
                                            <td class="el-table__cell">
                                                <div class="cell"><span>{{report_working.work_type}}</span></div>
                                            </td>
                                        </tr>
                                        <tr class="el-table__row">
                                            <td class="el-table__cell is-right">
                                                <div class="cell"><span>段顶(m)：</span></div>
                                            </td>
                                            <td class="el-table__cell">
                                                <div class="cell"><span>{{report_working.segment_top}}</span></div>
                                            </td>
                                            <td class="el-table__cell is-right">
                                                <div class="cell"><span>段底(m)：</span></div>
                                            </td>
                                            <td class="el-table__cell">
                                                <div class="cell"><span>{{report_working.segment_bottom}}</span></div>
                                            </td>
                                            <td class="el-table__cell is-right">
                                                <div class="cell"><span>设备编号：</span></div>
                                            </td>
                                            <td class="el-table__cell">
                                                <div class="cell"><span>{{report_working.device_code}}</span></div>
                                            </td>
                                            <td class="el-table__cell is-right">
                                                <div class="cell"><span>位置：</span></div>
                                            </td>
                                            <td class="el-table__cell">
                                                <div class="cell"><span>{{report_working.security_code}}</span></div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </el-card>
                </el-col>
            </el-row>
            <el-row style="width: 100%; margin-top: 20px;margin-left:0;margin-right:0;" :gutter="20">
                <el-col :span="8" style="padding-left: 0;height:100%">
                    <el-alert :title="'流量：'+flow1+'(L/Min)'" type="warning" :closable="false"></el-alert>
                </el-col>
                <el-col :span="8" style="padding-left: 0;height:100%">
                    <el-alert :title="'压力：'+pressure1+'(Mpa)'" type="warning" :closable="false"></el-alert>
                </el-col>
                <el-col :span="8" style="padding-left: 0;height:100%">
                    <el-alert :title="'密度：'+density1+'(g/cm3)'" type="warning" :closable="false"></el-alert>
                </el-col>
            </el-row>
            <el-row style="width: 100%; height: 365px; margin-top: 20px;">
                <el-col :span="24" style="padding-left: 0;height:100%">
                    <el-card class="box-card" style="height: 100%">
                        <div slot="header" class="clearfix">
                            <span>采样数据</span>
                        </div>
                        <el-table :data="samplingList" border stripe height="280">
                            <el-table-column prop="sampling_time_str" label="时间" sortable="custom" width="100"></el-table-column>
                            <el-table-column prop="flow" label="流量(L/Min)" sortable="custom"></el-table-column>
                            <el-table-column prop="pressure" label="压力(Mpa)" sortable="custom"></el-table-column>
                            <el-table-column prop="density" label="密度(g/cm3)" sortable="custom"></el-table-column>
                            <el-table-column prop="grout_volume" label="注浆量(L)" sortable="custom" v-if="report_working.work_type_int ==1 || report_working.work_type_int ==4 || report_working.work_type_int ==5"></el-table-column>
                            <el-table-column prop="permeable_rate" label="透水率(Lu)" sortable="custom" v-if="report_working.work_type_int ==2 || report_working.work_type_int ==3"></el-table-column>
                            <el-table-column prop="remark" label="备注" sortable="custom" width="100"></el-table-column>
                        </el-table>
                    </el-card>
                </el-col>
            </el-row>
            <el-row style="width: 100%; height: 365px; margin-top: 20px;">
                <el-col :span="24" style="padding-right: 0;height:100%">
                    <el-card class="box-card" style="height: 100%">
                        <div slot="header" class="clearfix">
                            <span>数据统计图</span>
                        </div>
                        <el-radio-group v-model="echarts_show" size="small" @input="changeEcharts">
                            <el-radio-button label="1">流量</el-radio-button>
                            <el-radio-button label="2">压力</el-radio-button>
                            <el-radio-button label="3">密度</el-radio-button>
                            <el-radio-button label="4">抬动</el-radio-button>
                        </el-radio-group>
                        <div class="echarts1" id="myChart1">
                            
                        </div>
                    </el-card>
                </el-col>
            </el-row>
        </el-card>
    </div>
</template>

<script>
import listutil from "@/libs/listutil"
import LabBtns from "@/components/common/labbtns"
import { workingList, workingInfo, getRealTimeDataByDeviceCode } from "@/api/moniter"

// 引入基本模板
let echarts = require('echarts/lib/echarts')
require('echarts/lib/chart/line')
require('echarts/lib/chart/pie')
require('echarts/lib/chart/scatter')
require('echarts/lib/component/tooltip')
require('echarts/lib/component/grid')
require('echarts/lib/component/legend')
require('echarts/lib/component/title')

export default {
    name: 'extractWorkingReport',
    mixins: [listutil],
    components: { LabBtns },
    data() {
        return {
            menu_id: 4300,
            m_name: '施工实时监测',
            main_btns: [],
            lab_btns: [],
            report_list: [],
            report_id: 0,
            report_working: {
                work_type_int: 1
            },
            device_code: '',
            flow1: '-',
            pressure1: '-',
            density1: '-',
            samplingList: [],
            echarts_show: 0,
            line1: [],
            line2: [],
            line3: [],
            line4: [],
            option: {
                tooltip: {
                    trigger: 'axis'
                },
                grid: {
                    left: '8%',
                    right: '4%',
                    bottom: '0',
                    containLabel: true
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: []
                },
                yAxis: {
                    name:'',
                    type: 'value'
                },
                series: [
                    {
                        name: '',
                        type: 'line',
                        areaStyle: {},
                        data: []
                    }
                ]
            },
        };
    },
    mounted(){
        this.getWorkingList()
    },
    methods: {
        getData() {
            this.getBtnsData();     //按钮权限数据
        },
        getWorkingList(){
            this.report_list = []
            workingList().then(res=>{
                if(res.code ==1){
                    this.report_list = res.data
                }
                this.$globalData.timmer3 && clearTimeout(this.$globalData.timmer3)
                this.$globalData.timmer3 = setTimeout(() => {
                    this.getWorkingList()
                }, 60*1000);
            })
        },
        info(index, row) {
            this.report_id = row.id
            this.device_code = row.device_code
            this.getWorkingInfo()
            this.getRealTimeData()
        },
        getWorkingInfo(){
            if(this.report_id == undefined || this.report_id <= 0){
                return
            }
            this.report_working = {}
            workingInfo(this.report_id).then(res=>{
                if (res.code === 1) {
                    this.report_working = res.data.workReport
                    this.samplingList = res.data.samplingList
                    this.msgList = res.data.msgList
                    this.line1 = res.data.line1
                    this.line2 = res.data.line2
                    this.line3 = res.data.line3
                    this.line4 = res.data.line4
                    this.option.xAxis.data = res.data.xAxis
                    this.echarts_show = '1'
                    this.changeEcharts('1')
                } else {
                    this.$msg(res.msg)
                    this.closeDialog()
                }
                this.$globalData.timmer4 && clearTimeout(this.$globalData.timmer4)
                this.$globalData.timmer4 = setTimeout(() => {
                    this.getWorkingInfo()
                }, 20*1000);
            })
        },
        getRealTimeData(){
            var that = this
            getRealTimeDataByDeviceCode(this.device_code).then(res=>{
                if(res.code == 1){
                    let vo = res.data
                    if(this.$isNotNull(vo)){
                        that.flow1 = vo.flow1
                        that.pressure1 = vo.pressure1
                        that.density1 = vo.density1    
                    }else{
                        that.flow1 = '-'
                        that.pressure1 = '-'
                        that.density1 = '-'
                    }
                    this.$globalData.timmer5 && clearTimeout(this.$globalData.timmer5)
                    this.$globalData.timmer5 = setTimeout(() => {
                        this.getRealTimeData()
                    }, 1000);
                }
            })
        },
        changeEcharts(e){
            if(e =='1'){
                this.option.yAxis.name = '流量(L/Min)'
                this.option.series[0].name = '流量(L/Min)'
                this.option.series[0].data = this.line1
            }else if(e=='2'){
                this.option.yAxis.name = '压力(Mpa)'
                this.option.series[0].name = '压力(Mpa)'
                this.option.series[0].data = this.line2
            }else if(e=='3'){
                this.option.yAxis.name = '密度(g/cm3)'
                this.option.series[0].name = '密度(g/cm3)'
                this.option.series[0].data = this.line3
            }else if(e=='4'){
                this.option.yAxis.name = '抬动(um)'
                this.option.series[0].name = '抬动(um)'
                this.option.series[0].data = this.line4
            }
            var myChart1 = echarts.init(document.getElementById("myChart1"));
            myChart1.setOption(this.option);
        },
    }
};
</script>
<style lang="less" scoped>
    .el-table /deep/ .el-table__cell {
        padding: 10px 0;
    }
    .el-card /deep/ .el-card__header {
        padding: 10px 20px;
    }
    .echarts1{
        width: 100%;
        height: 250px;
        margin-top: 0;
    }
</style>